import { Component, OnInit, Input } from '@angular/core';
import { AjusteInventario } from '../../../models/ajuste-inventario';
import { AjusteInventarioService } from '../../../services/ajuste-inventario.service';
import { ProductoService } from '../../../services/producto.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { SerieService } from '../../../services/serie.service';
import { MovimientoService } from '../../../services/movimiento.service';
import { SerieDetalleModalComponent } from '../serie-detalle-modal/serie-detalle-modal.component';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-ajuste-inventario-modal',
  templateUrl: './ajuste-inventario-modal.component.html',
  styleUrls: ['./ajuste-inventario-modal.component.css'],
  providers: [
    AjusteInventarioService,
    ProductoService,
    SerieService,
    MovimientoService,
  ]
})
export class AjusteInventarioModalComponent implements OnInit {
  @Input() ajuste_id: String;
  public ajuste: AjusteInventario;
  public loading = false;
  public detalles: any;
  public numero_decimales: String;
  public bsModalRef2: BsModalRef;
  constructor(
    private ajusteService: AjusteInventarioService,
    private productoService: ProductoService,
    private serieService: SerieService,
    private movimientoService: MovimientoService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) {
    this.ajuste = new AjusteInventario();
    this.detalles = [];
  }

  ngOnInit() {
    this.getAjusteById();
  }

  getTipo(tipo) {
    return tipo == 'E' ? "Ingreso" : "Egreso";
  }

  getBodega(bodega) {

  }

  getCodigoSerie(codigo = ''){
    return codigo + ', ';
  }

  getAjusteById() {
    this.loading = true;
    this.ajusteService.getById(this.ajuste_id,"?embed=bodega,movimiento?embed=detalle?embed=producto").subscribe(
      res=>{
        this.ajuste = res;
        this.ajuste.movimiento.detalle.forEach(detalle =>{
          let qs = "?embed=producto?embed=categoria";
          qs += ((this.ajuste.tipo == 'E'?',seriesingreso':',seriesegreso')+'?embed=serie');
          this.movimientoService.getDetalleById(detalle.id, qs).subscribe(
            res => {
              detalle.producto = res.data.producto;
              detalle.series = this.ajuste.tipo=='E'?res.data.seriesingreso:res.data.seriesegreso;
              this.loading = false;
            },
            err => {
                this.loading = false;
            }
          );
        }); 
      }, err=>{
          this.loading = false;
        }  
     
      
    );
  }

  openModalSerie(series: Array<any>) {
		const initialState = { series: series,numero_decimales: this.numero_decimales };
		this.bsModalRef2 = this.modalService.show(SerieDetalleModalComponent, Object.assign({backdrop: 'static',initialState }));

		
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/ajuste-inventario-modal/ajuste-inventario-modal.component.ts